<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length > 1 ? "UPDATE" : "ADD NEW" }}
        ATTENDANCE
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">

        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <p class="w-full mt-5">
              Date Start
              <datepicker :inline="false" v-model="datadateStart"></datepicker>
            </p>
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              label="Hour"
              v-model="datatimeStart"
              class="mt-5 w-full"
              name="datatimeStart"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('datatimeStart')"
              >{{ errors.first("datatimeStart") }}</span
            >
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <p class="w-full mt-5">
              Date Stop
              <datepicker :inline="false" v-model="datadateStop"></datepicker>
            </p>
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              label="Hour"
              v-model="datatimeStop"
              class="mt-5 w-full"
              name="datatimeStop"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('datatimeStop')"
              >{{ errors.first("datatimeStop") }}</span
            >
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-input
              label="Comment"
              v-model="datacomment"
              class="mt-5 w-full"
              name="datacomment"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('datacomment')"
              >{{ errors.first("datacomment") }}</span
            >
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moduleDataListProduct from "@/store/products/product/moduleDataList.js";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      dataIdPerson: null,
      dataId: null,
      datadateStart: null,
      datatimeStart: null,
      datadateStop: null,
      datatimeStop: null,
      datacomment: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 1) {
        this.initValues();
        this.$validator.reset();
        this.dataIdPerson = this.data.idperson;
        this.datadateStart = moment().format("yyyy-MM-DD");
        this.datadateStop = moment().format("yyyy-MM-DD");
      } else {
        this.dataIdPerson = this.data.idperson;
        this.datadateStart = moment(this.data.datestart).format("yyyy-MM-DD");
        this.datatimeStart = moment(this.data.datestart).format("HH:mm:ss");
        this.datadateStop = moment(this.data.datestop).format("yyyy-MM-DD");
        this.datatimeStop = moment(this.data.datestop).format("HH:mm:ss");
        this.datacomment = this.data.comment;
        this.dataId = this.data.id;
        this.initValues();
      }
    },
  },
  computed: {
    validName() {
      return this.dataNameProdEN;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return !this.errors.any() || this.data.id;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    initValues() {
      if (this.data.id) return;
      this.dataIdPerson = "";
      this.datadateStart = "";
      this.datadateStop = "";
      this.datacomment = "";
      this.dataId = "";
      this.datatimeStop = "";
      this.datatimeStart = "";
    },
    submitData() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let datestop = null
            if (this.datatimeStop) datestop =  moment(moment(this.datadateStop).format("YYYY-MM-DD")+ " "+this.datatimeStop).utc()
            var obj = {
                  id : this.dataId,
                  comment: this.datacomment,
                  datestart: moment(moment(this.datadateStart).format("YYYY-MM-DD")+ " "+this.datatimeStart).utc(),
                  datestop: datestop,
                  idperson: this.dataIdPerson
            }
            if (this.dataId && this.dataId >= -1) {
              this.$store
                .dispatch("dataListEmployee/updatePresence", obj)
                .then((res) => {
                  this.$vs.notify({
                    color: "success",
                    title: "Attendace Updated!",
                    text: "The Attendace was successfully updated",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                })
                .catch((err) => {
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "The time format is not recognized!",
                    text: "The Attendace was NOT updated",
                  });
                });
            } else {
              delete obj.id;
              this.$store
                .dispatch("dataListEmployee/createPresence", obj)
                .then((res) => {
                  this.$vs.notify({
                    color: "success",
                    title: "Attendace Created!",
                    text: "The Attendace was successfully added",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                })
                .catch((err) => {
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "The time format is not recognized!",
                    text: "The Attendace was NOT updated",
                  });
                });
            }
          }
        });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
